import IntermodalRouteType from "@Intermodal/types/IntermodalRoute.type";
import IntermodalRouteWithDetailsType from "@Intermodal/types/IntermodalRouteWithDetails.type";
import RouteType from "@Route/types/Route.type";

export const isIntermodalRoute = (route: RouteType|IntermodalRouteType): route is IntermodalRouteType | IntermodalRouteWithDetailsType => (
    route?.isIntermodalRoute
)
